<template>
  <div v-show="shouldDisplayColorSelectMenuAndLabel">
    <label
      :for="`${isIndicatorColorMenu ? 'indicator' : 'overlay'}-color-menu-${id}`"
      class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
      v-if="shouldShowLabel"
    >COLOR</label>
    <br v-if="shouldShowLabel" />
    <select
      :class="{ 'hidden': !shouldDisplayColorSelectMenu }"
      class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-compact sc3-select-menu-white-and-grey sc3-select-menu-no-margins"
      :id="`${isIndicatorColorMenu ? 'indicator' : 'overlay'}-color-menu-${id}`"
      :value="color"
      @change="colorMenuChanged($event)"
    >
      <option
        v-for="upColorOption in chartStore.upDownColorsArray"
        :key="upColorOption"
        :value="upColorOption"
      >{{ upColorOption }}</option>
    </select>
  </div>
</template>

<script lang="ts" setup>
  import { toRefs, computed } from 'vue';
  import { NONE, DATE_TIME_AXIS, VOLUME_BY_PRICE } from '@/enums/indicators-and-overlays';
  import { useChartStore } from '@/stores/chartStore';

  const chartStore = useChartStore();
  const props = defineProps<{
    color: string;
    isIndicatorColorMenu: boolean;
    id: number;
    shouldShowLabel: boolean;
    isAtLeastOneNonVolumeByPriceOverlayPresent: boolean;
    isAtLeastOneNonDateTimeAxisIndicatorPresent: boolean;
    indicatorOrOverlayName: string;
  }>();
  const {
    color,
    isIndicatorColorMenu,
    id,
    shouldShowLabel,
    isAtLeastOneNonVolumeByPriceOverlayPresent,
    isAtLeastOneNonDateTimeAxisIndicatorPresent,
    indicatorOrOverlayName
  } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:color', color: string): void;
    (e: 'colorChanged'): void;
  }>();

  const shouldDisplayColorSelectMenuAndLabel = computed(() => {
    return (
      (!isIndicatorColorMenu.value && isAtLeastOneNonVolumeByPriceOverlayPresent.value) ||
      (isIndicatorColorMenu.value && isAtLeastOneNonDateTimeAxisIndicatorPresent.value)
    );
  });

  const shouldDisplayColorSelectMenu = computed(() => {
    return !!indicatorOrOverlayName.value && ![NONE, DATE_TIME_AXIS.name, VOLUME_BY_PRICE.name].includes(indicatorOrOverlayName.value);
  });

  function colorMenuChanged(e: Event) {
    if (!(e.target instanceof HTMLSelectElement)) {
      return;
    }

    emit('update:color', e.target.value);
    emit('colorChanged');
  }
</script>

<style scoped>
  .hidden {
    visibility: hidden;
  }
</style>
